import { AxiosRequestConfig } from "axios";

import { axiosInstance } from "../api/axiosConfig";

export interface CreationData {
    name?: string
    tags?: any[]
    visibility?: string
    risk_level?: string
    assets: Asset[]
    description?: string
}

export interface Asset {
    asset_id: number | string
    weight: number
}


export const getTemplates = async (options: AxiosRequestConfig) => {
    return await axiosInstance.get(`/sa_template/all`, options);
};

export const getTemplateById = async (options: AxiosRequestConfig) => {
    return await axiosInstance.get('/sa_template', options);
}

export const controlTemplate = async (data: CreationData, options: AxiosRequestConfig) => {
    return await axiosInstance.put('/sa_template', data, options);
}

export const deleteTemplate = async (options: AxiosRequestConfig) => {
    return await axiosInstance.delete('/sa_template', options);
}

export const syncTemplate = async (options: AxiosRequestConfig) => {
    return await axiosInstance.post('/sa_template/sync', {}, options);
}

export const unsyncTemplate = async (options: AxiosRequestConfig) => {
    return await axiosInstance.get('/sa_template/unsync', options);
}